import { render, staticRenderFns } from "./ImportCockpitView.vue?vue&type=template&id=1b3c9b4a"
import script from "./ImportCockpitView.vue?vue&type=script&lang=js"
export * from "./ImportCockpitView.vue?vue&type=script&lang=js"
import style0 from "./ImportCockpitView.vue?vue&type=style&index=0&id=1b3c9b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports